import {Alert} from "react-bootstrap";
import React, {useState} from "react";
import './CustomAlert.css';

function CustomAlert(props) {

    const [show, setShow] = useState(true);

    if (show) {
        return (
            <div className="div-alert">
                <Alert dismissible onClose={() => setShow(false)} variant={props.variant}>
                    {props.message}
                </Alert>
            </div>
        );
    } else {
        return null;
    }
}

export default CustomAlert;